'use client'

import Link from 'next/link'
import Facebook from 'public/assets/blog/facebook.svg'
import Copy from 'public/assets/blog/link.svg'
import LinkedIn from 'public/assets/blog/linkedIn.svg'
import Share from 'public/assets/blog/share.svg'
import X from 'public/assets/blog/x.svg'
import { useEffect, useState } from 'react'
import styles from './ShareButtons.module.scss'

type ShareButtonsProps = {
  webShareTitle: string
  webShareText: string
}

const ShareButtons = ({ webShareText, webShareTitle }: ShareButtonsProps) => {
  const [facebookShareLink, setFacebookShareLink] = useState('')
  const [linkedinShareLink, setLinkedInShareLink] = useState('')
  const [xShareLink, setXShareLink] = useState('')
  const [isWebShareVisible, setIsWebShareVisible] = useState<boolean>(true)
  const [shareData, setShareData] = useState<ShareData | undefined>(undefined)
  const [copied, setCopied] = useState(false)

  async function copyToClipboard() {
    await navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  const shareInfo = async () => {
    try {
      if (testCanShare() && navigator.canShare(shareData)) {
        await navigator.share(shareData)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const testCanShare = (): boolean => {
    try {
      if (navigator && navigator['share'] && navigator['canShare']) return true
    } catch {
      return false
    }

    return false
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setFacebookShareLink(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`)
    setLinkedInShareLink(`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`)
    setXShareLink(`https://twitter.com/intent/tweet?url=${window.location.href}`)
    setShareData({
      title: webShareTitle,
      text: webShareText,
      url: window.location.href,
      files: [],
    })
    setIsWebShareVisible(testCanShare())
  }, [webShareText, webShareTitle])

  return (
    <div className={styles.share}>
      <span>Share</span>
      <div className={styles.socials}>
        <div className={styles.tooltip + (copied ? ' ' + styles.copied : '')}>
          <Copy onClick={copyToClipboard} />
          <span className={styles['tooltip-text']}>Copied!</span>
        </div>

        {isWebShareVisible && (
          <div>
            <Share onClick={shareInfo} />
          </div>
        )}

        <Link href={facebookShareLink} target='_blank' rel='noopener noreferrer' className={styles.link}>
          <span>Facebook</span>
          <Facebook />
        </Link>

        <Link href={xShareLink} target='_blank' rel='noopener noreferrer' data-size='large' className={styles.link}>
          <span>X</span>
          <X />
        </Link>

        <Link href={linkedinShareLink} target='_blank' rel='noopener noreferrer' className={styles.link}>
          <span>LinkedIn</span>
          <LinkedIn />
        </Link>
      </div>
    </div>
  )
}

export default ShareButtons
